import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import Switch from '@material-ui/core/Switch';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

const OnOffSwitch = withStyles(theme => ({
  switchBase: {
    color: theme.palette.primary.main,
    '&$checked': {
      color: theme.palette.secondary.main,
    },
    '&$checked + $track': {
      backgroundColor: grey[800],
    },
  },
  checked: {},
  track: {},
}))(Switch);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
  },
  leftOn: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  rightOn: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
  },
}));

const SelectionSwitch = ({ rightLabel, leftLabel, value, setValue }) => {
  const classes = useStyles();
  const [state, setState] = useState(value);

  const handleChange = value => {
    setState(value);
    setValue(value);
  };

  return (
    <div className={classes.root}>
      <Typography className={clsx({ [classes.leftOn]: !state })} onClick={() => handleChange(false)}>
        {leftLabel}
      </Typography>
      <OnOffSwitch checked={state} onChange={() => handleChange(!state)} name="checkOnOff" />
      <Typography className={clsx({ [classes.rightOn]: state })} onClick={() => handleChange(true)}>
        {rightLabel}
      </Typography>
    </div>
  );
};

export default SelectionSwitch;
